import { PostProperties } from "../types";
import image from "../img/lostGemRodhad.jpg";

const post: PostProperties = {
  id: 15,
  title: "Rødhåd - Onemore, Hearn Street Car Park, London (27.04.2013)",
  content:
    "Well-known for his signature sound, Rødhåd is currently one of Berlin's most exciting talents.",
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/rodhad-onemore-hearn-street-car-park-london-27042013",
  category: "Lost Gem",
  translationsBg: {
    content:
      "Широко известен с характерния си звук, Rødhåd е сред най-вълнуващите таланти на Берлин в момента.",
  },
};

export default post;
